import request from './request'

export function listReservation(data) {
  return request.post('/inventory/reservations/list', data)
}
export function getReservation(id) {
  return request.get('/inventory/reservations/' + id)
}
export function createReservation(data) {
  return request.post('/inventory/reservations', data)
}
export function releaseReservation(reservationId) {
  return request.post('/inventory/reservations/release', { reservationId })
}
